<template>
  <div>
    <base-select-search
      placeholder="Cari Bank"
      :is-loading="loading"
      :data="data"
      :shadow="shadow"
      :fullwidth="fullwidth"
      :input-label="label"
      :inset="inset"
      label="name"
      v-model="selected"
      v-on:infinite-scroll="handleInfiniteScroll"
      v-on:search="handleSearch"
      v-on:change="handleChange"
    />
  </div>
</template>

<script>
import BaseSelectSearch from '@/components/base/BaseSelectSearch.vue';
import { requestMixin } from '@/mixins/request/request';

export default {
  name: 'BankSelectSearch',
  mixins: [requestMixin],
  components: { BaseSelectSearch },
  props: {
    value: null,
    limit: {
      type: Number,
      default: 10,
    },
    shadow: {
      type: Boolean,
      default: true,
    },
    fullwidth: Boolean,
    inset: Boolean,
    label: String
  },
  emits: ['input', 'change'],
  data: function () {
    return {
      search: null,
      size: null,
      loading: false,
      banks: {
        data: [],
        meta: {
          page: {},
        },
      },
    };
  },
  computed: {
    selected: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit('input', value);
      },
    },
    data() {
      return this.banks.data.map(bank => ({ id: bank.id, attributes: { name: bank.attributes.name } }))
    }
  },
  methods: {
    init: function () {
      this.size = this.limit;

      this.loadBanks();
    },
    loadBanks: async function () {
      this.loading = true;

      const [res, error] = await this.request('/api/v1/banks', {
        params: {
          'page[size]': this.size,
          'filter[search]': this.search,
          'fields[banks]': 'name',
        },
      });

      if (!error) {
        this.banks = res;
      }

      this.loading = false;
    },
    handleInfiniteScroll: function () {
      if (this.size < this.banks.meta.page.total) {
        this.size += this.limit;

        this.loadBanks();
      }
    },
    handleSearch: function (search) {
      this.size = this.limit;
      this.search = search;

      this.loadBanks();
    },
    handleChange: function () {
      this.$emit('change');
    },
  },
  created: function () {
    this.init();
  },
};
</script>
